import { caseTypes } from "components/Utility/Objects";
import { caseTypeDefault, stringFieldDefault, userDefault } from "components/Utility/PropDefaults";
import { userShape, addressShape } from "components/Utility/PropShapes";

//use this to combine classes instead of dirty string interpolation and logic trying to put spaces in between classes
const classes = (...classes) => classes.filter(c => c).join(" ");
  
export {
    caseTypes,
    caseTypeDefault,
    stringFieldDefault,
    userDefault,
    userShape,
    addressShape,
    classes,
};
